import Vue from "vue";
import {Component} from "vue-property-decorator";
import UserActionResultSender from "@/components/application/UserActionResultSender";
import {AXIOS} from "@/lib/http-common";
import {ExportOptions} from "@/components/properties/settings/export/model/ExportOptions";
import ManualPatternBuilder from "@/views/settings/export/file-name-pattern/ManualPatternBuilder.vue";
import {ExportType} from "@/components/properties/settings/export/model/ExportType";
import {ExportKey} from "@/components/properties/settings/export/model/ExportKey";
import Property from "@/components/properties/model/Property";

@Component({
  components: {ManualPatternBuilder},
  computed: {
    ExportOptions() {
      return ExportOptions;
    },

  }
})
export default class ExportItems extends Vue {

  public openExportItemsDialogOpened: boolean = false;
  public selectedFile: File | null = null;
  public fileError: string = "";
  public isFileValid: boolean = false;
  public destinationFolder: string = "";
  public defaultExportPath: string = "";
  public exportType: string = ExportType.JSON;
  public loading: boolean = false;
  public exportOption = "all";
  public dates: string[] = [];
  public maxDate = new Date().toISOString().substr(0, 10);
  public patternPreview: string = "";
  public databasePatternPreview: string = "";
  public showDialog: boolean = false;
  public exportRangeModal = false;

  public startDate: string | null = null;
  public endDate: string | null = null;


  public allowedDates(date: string): boolean {
    if (this.dates.length === 1) {
      const startDate = new Date(this.dates[0]);
      return new Date(date) >= startDate;
    }
    return true;
  }

  public mounted() {
    console.log("Export items mounted");
    this.openExportItemsDialog();
  }

  public openExportItemsDialog() {
    console.log("Opening export items dialog");
    this.openExportItemsDialogOpened = true;
    this.getDefaultDestinationFolder();
    this.getExportTypeFile();
    this.getManualExportFileNamePattern();
  }

  public closeExportItemsDialog() {
    this.openExportItemsDialogOpened = false;
    this.selectedFile = null;
    this.fileError = "";
    this.isFileValid = false;
    this.cancelDates();
    this.$router.push('/');
  }


  public async exportItems() {
    const params: { destinationFolder?: string, dateRanges?: string } = {};

    if (this.destinationFolder) {
      params.destinationFolder = this.destinationFolder;
    }
    if (this.dates) {
      if (this.dates.length === 1) {
        this.dates.push(this.dates[0]);
      }
      params.dateRanges = this.dates.join(",");
    }

    AXIOS.get("/export", {params}).then(value => {
      if (value.status !== 200) {
        UserActionResultSender.showErrorFeedback('items.import.error');
        return;
      }
      UserActionResultSender.showSuccessFeedback('items.export.success');
    })
      .catch((error) => {
        UserActionResultSender.showErrorFeedback('items.export.error');
      })
      .finally(() => {
        this.closeExportItemsDialog();
      });
  }

  public getDefaultDestinationFolder() {
    this.loading = true;
    AXIOS.get('/properties/export/default-folder')
      .then((message) => {
        this.defaultExportPath = message.data;
      })
      .catch(error => {
        UserActionResultSender.showErrorFeedback(error.response.data.responseCode);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  public dateRangeText() {
    return this.dates.join(' ~ ');
  }

  public cancelDates() {
    this.dates = [];
    this.startDate = null;
    this.endDate = null;
    this.exportRangeModal = false;
  }

  public getExportTypeFile() {
    console.log("Fetching export type file");
    AXIOS.get('/properties/exportType')
      .then((message) => {
        console.log(message.data.propValue);
        this.exportType = message.data.propValue;
      })
      .catch(error => {
        UserActionResultSender.showErrorFeedback(error.response.data.responseCode);
      })
      .finally(() => {
        this.loading = false;
      });
  }
  public getManualExportFileNamePattern() {
    console.log("Fetching export type file");
    AXIOS.get('/properties/manualExportFileNamePattern')
      .then((message) => {
        console.log(message.data.propValue);
        this.patternPreview = message.data.propValue;
        this.databasePatternPreview = message.data.propValue;
      })
      .catch(error => {
        UserActionResultSender.showErrorFeedback(error.response.data.responseCode);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  get exportTypeFileShort(): string {
    switch (this.exportType) {
      case ExportType.JSON:
      case ExportType.JSON_CUSTOM:
        return "json";
      case ExportType.CSV:
        return "csv";
      case ExportType.XML:
        return "xml";
      default:
        return "";
    }
  }

  public onPatternUpdate(newPattern: string) {
    this.patternPreview = newPattern;
    this.showDialog = false;
    const propertyDto: Property = {propKey: ExportKey.MANUAL_EXPORT_FILE_PATTERN, propValue: this.patternPreview};
    AXIOS.put(`/properties/export`, propertyDto)
      .catch(error => {
        UserActionResultSender.showErrorFeedback(error.response.data.responseCode);
      });
  }
}
